import apiUrl from "../../../constants";
import axios from "axios";
import CryptoJS from "crypto-js";
import VueElementLoading from "vue-element-loading";
import Multiselect from "vue-multiselect";
import utils from "../../../utils/validateScanner";
import {
  Validator
} from 'vee-validate'

export default {
  name: "FacilityConfig",
  mixins: [utils],
  components: {
    VueElementLoading,
    Multiselect,
  },
  data() {
    return {
      facilityConfigData: [],
      facilityId: '',
      configType: "FWD",
      input: {},
      userid: "",
      lastmodifiedby: "",
      hub_id: "",
      hubitem: {
        value: "",
        text: "",
      },
      hubnameerror: "",
      isLoading: false,
      showModal: false,
      isLoadingSave: false,
      hubitemAdd: null,
      addForm: {
        facilityHubId: "",
        facilityHubName: "",
        generateconfig: false,
        fwd: true,
        fwdfrequency: 1,
        dto: false,
        dtofrequency: 0,
        autoactivate: false,
      },
    };
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem("userdetail");
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), "Key");
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userid = userdetail[0].userid;
    this.lastmodifiedby = userdetail[0].email;
    //  this.hub_id =userdetail[0].HubId[0]
    this.getHubList();
  },

  methods: {
    setSelectedHub(hubitem) {
      this.hub_id = hubitem.value;
      this.hubname = hubitem.text.split("(")[0].trim();
      this.hubitem = hubitem;
      if (this.hubname == "") {
        this.hubnameerror = "Select Hub Name";
      } else {
        this.hubnameerror = "";
      }
    },

    setSelectedHubToAdd(hubitem) {
      this.addForm.facilityHubId = hubitem.value;
      this.addForm.facilityHubName = hubitem.text.split("(")[0].trim();
      this.hubitemAdd = hubitem;
      this.hubnameerror = this.addForm.facilityHubName ? "" : "Select Facility";
    },

    searchHub(hubid) {
      if (hubid != "") {
        this.hubnameerror = "";
        this.getFacilityConfig(hubid);
      } else {
        this.hubnameerror = "Select Hub Name";
        return false;
      }
    },
    getFacilityConfig(hubid) {
      this.isLoading = true;
      axios({
        method: "GET",
        url: `${apiUrl.api_url_hubops}getFacilityConfig?facilityId=${hubid}&configType=FWD`,
        headers: {
          authorization: "authkey xB84JJ89Hd25",
        },
      }).then(
        (result) => {
          if (result.data.ResultCode == 100) {
            this.facilityConfigData = result.data.ResponseData;
          } else {
            this.facilityConfigData = [];
          }
          this.isLoading = false;
        },
        (error) => {
          this.isLoading = false;
          console.error(error);
          this.$alertify.error("Something went wrong");
        }
      );
    },
    submitForm() {
      this.$validator.validateAll().then(valid => {
      if (!valid) {
        return;
      }

      this.insertFacilityConfig();
    });
  },

   
    async insertFacilityConfig() {
      this.isLoadingSave = true;

      const payload = {
        module: "HubOps",
        facilityHubId: this.addForm.facilityHubId,
        facilityHubName: this.addForm.facilityHubName,
        generateConfig: this.addForm.generateconfig,
        fwd: true,
        fwdFrequency: Number(this.addForm.fwdfrequency),
        dto: this.addForm.dto,
        dtoFrequency: Number(this.addForm.dtofrequency),
        autoActivate: this.addForm.autoactivate,
        createdBy: this.lastmodifiedby,
      };
      try {
        const result = await axios.post(
          apiUrl.api_url_hubops + "insertFacilityConfigData",
          payload,
          { headers: { authorization: "authkey xB84JJ89Hd25" } }
        );
        if (result.data.ResultCode == 101){
           this.$alertify.error(result.data.ReturnMessage);
        }
        else if (result.data.ResultCode == 100) {
          this.$alertify.success("Facility Config Added Successfully");
                 } else {
          this.$alertify.error("Error adding config");
        }
        this.resetForm();
      } catch (e) {
        console.error(e);
        this.$alertify.error("Something went wrong");
      }

      this.isLoadingSave = false;
    },

    updateFaclility(data) {
      this.isLoading = true;
      this.input = {
        facilityHubId: this.hub_id,
        generateConfig: data.generateconfig,
        fwd: data.fwd,
        fwdFrequency: data.fwdfrequency,
        dto: data.dto || false,
        dtoFrequency: data.dtoFrequency || 0,
        autoActivate: data.autoactivate,
        lastModifiedBy: this.lastmodifiedby,
      };
      axios({
        method: "POST",
        url: apiUrl.api_url_hubops + "updateFacilityConfigData",
        data: this.input,
        headers: {
          authorization: "authkey xB84JJ89Hd25",
        },
      }).then(
        (result) => {
          if (result.data.ResultCode == 100) {
            this.$alertify.success("Facility Config updated successfully");
          }
          this.isLoading = false;
        },
        (error) => {
          this.isLoading = false;
          this.$alertify.error("Something went wrong, please try again later");
          console.error(error);
        }
      );
    },
    resetData() {
      this.isLoading = false;
      (this.hubitem = {
        value: "",
        text: "",
      }),
        (this.hub_id = ""),
        (this.facilityConfigData = []);
      this.hubname = "";
      this.hubnameerror=''
    },
    resetForm() {
      this.addForm = {
        facilityHubId: "",
        facilityHubName: "",
        generateconfig: false,
        fwd: true,
        fwdfrequency: 1,
        dto: false,
        dtofrequency: 0,
        autoactivate: false,
      };
      this.hubitemAdd = null;
      this.$validator.reset();
      this.errors.clear();

    },
    closeForm() {
      this.showModal = false;
      this.resetForm();
    },
    openAddModal() {
  this.resetForm();        
  this.showModal = true;  
  }
  },
};



// WEBPACK FOOTER //
// ./src/views/components/FacilityConfig/FacilityConfig.js